module.exports = __webpack_public_path__ + "img/security_background.4309abb2.jpg";